import { render } from "./ModeratorForm.vue?vue&type=template&id=6a21fd5d"
import script from "./ModeratorForm.vue?vue&type=script&lang=js"
export * from "./ModeratorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__